import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, dimensions } from '../../styles';
import { rgba } from '../../styles/color';

const Item = styled.li`
  display: inline-block;
  margin: 5px;
  color: ${rgba(colors.colorCoreDarkGray, 0.9)};
  text-transform: capitalize;
  font-weight: 500;
  border-radius: 9px;
  text-align: left;
  
  @media (max-width:768px) {

  }

  span {
    padding: 7px;
    border-radius: 9px;
    border: 3px solid ${colors.themeBlue};
    // background-color: ${colors.themeBlue}
    color: ${colors.themeBlue};
  }
  > a {
    text-decoration: none;
    padding: 6px;
    border-radius: 9px;
    // color: ${rgba(colors.colorCoreDarkGray, 0.4)};
    color: #000;
    border: 2px solid ${colors.colorCoreLightGray};
    
  }
  
  
`;

const propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  to: PropTypes.string,
  title: PropTypes.node,
  target: PropTypes.string
};

const defaultProps = {
  active: false
};

function CommonBreadcrumbItem({ active, to, title, target, children, ...props }) {
  const linkProps = { to, title, target };

  return (
    <Item>
      {active ? (
        <span {...props}>{children}</span>
      ) : (
        <Link {...props} {...linkProps}>
          {children}
        </Link>
      )}
    </Item>
  );
}

CommonBreadcrumbItem.propTypes = propTypes;
CommonBreadcrumbItem.defaultProps = defaultProps;

export default CommonBreadcrumbItem;



// WEBPACK FOOTER //
// ./src/modules/common/components/commonPageHeader/CommonBreadCrumbItem.js